/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DnspDerEventDevice
 */
export interface DnspDerEventDevice {
    /**
     *
     * @type {string}
     * @memberof DnspDerEventDevice
     */
    deviceId?: string;
    /**
     * Eg ChargePoint, Wave
     * @type {string}
     * @memberof DnspDerEventDevice
     */
    deviceType?: string;
    /**
     * Date the device owner opted out of this event, or null if they have not
     * @type {Date}
     * @memberof DnspDerEventDevice
     */
    optedOutAt?: Date;
    /**
     * If user opted out via SMS, contains their reply eg 'SMS: NO'. If an error occured eg device offline, contains 'Error: <msg>'
     * @type {string}
     * @memberof DnspDerEventDevice
     */
    optOutReason?: string;
    /**
     * TODO NYI. If there was an EV plugged in at any time during the event
     * @type {boolean}
     * @memberof DnspDerEventDevice
     */
    didPlugIn?: boolean;
    /**
     * TODO NYI. If there was an EV plugged in and actually charged during the event
     * @type {boolean}
     * @memberof DnspDerEventDevice
     */
    didCharge?: boolean;
    /**
     * TODO NYI. The estimated amount of power saved (load shed) by this device during the event. See https://jetcharge.atlassian.net/browse/ILLUM-765 for a discussion of how this is calculated.
     * @type {number}
     * @memberof DnspDerEventDevice
     */
    powerSavedWh?: number;
}

/**
 * Check if a given object implements the DnspDerEventDevice interface.
 */
export function instanceOfDnspDerEventDevice(
    value: object,
): value is DnspDerEventDevice {
    return true;
}

export function DnspDerEventDeviceFromJSON(json: any): DnspDerEventDevice {
    return DnspDerEventDeviceFromJSONTyped(json, false);
}

export function DnspDerEventDeviceFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DnspDerEventDevice {
    if (json == null) {
        return json;
    }
    return {
        deviceId: json["deviceId"] == null ? undefined : json["deviceId"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        optedOutAt:
            json["optedOutAt"] == null
                ? undefined
                : new Date(json["optedOutAt"]),
        optOutReason:
            json["optOutReason"] == null ? undefined : json["optOutReason"],
        didPlugIn: json["didPlugIn"] == null ? undefined : json["didPlugIn"],
        didCharge: json["didCharge"] == null ? undefined : json["didCharge"],
        powerSavedWh:
            json["powerSavedWh"] == null ? undefined : json["powerSavedWh"],
    };
}

export function DnspDerEventDeviceToJSON(
    value?: DnspDerEventDevice | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceId: value["deviceId"],
        deviceType: value["deviceType"],
        optedOutAt:
            value["optedOutAt"] == null
                ? undefined
                : value["optedOutAt"].toISOString(),
        optOutReason: value["optOutReason"],
        didPlugIn: value["didPlugIn"],
        didCharge: value["didCharge"],
        powerSavedWh: value["powerSavedWh"],
    };
}
